import React from 'react';
import n2loading from './n_2_logo_animated.gif';
export default function LoadingAnimation({height}) {
  return(
    <img src={n2loading} alt="Loading..." style={{"width":"auto", height: `${height??"100px"}`}} className='filter grayscale brightness-50' />
  )
}